export default "__VITE_ASSET__vjd_k5qQ__"